document.addEventListener("DOMContentLoaded", function () {
    // Всі переклади прямо тут
    var translations = {
      en: {
        banner: {
          title: "We respect your privacy!",
          description: "By clicking “Accept all”, you agree that our website can store cookies on your device and disclose information in accordance with our Cookie Policy.",
          accept_all: "Accept all",
          manage: "Manage preferences",
          privacy_policy: "Privacy policy"
        },
        prefs: {
          title: "Cookie consent preferences",
          disclaimer_title: "Cookie Usage",
          disclaimer_desc: "Our website uses cookies to enhance your browsing experience. These cookies don't directly identify you but personalize your visit. You can manage your preferences, although blocking some cookies may impact the site's services.",
          categories: [
            {
              header: "Strictly required cookies",
              desc: "These cookies are crucial for site function and cannot be blocked. Blocking them might affect how our site works."
            },
            {
              header: "Functionality cookies",
              desc: "These cookies add extra features and personalization to our site. They're set by us or third-party providers. Not allowing these may affect certain services' functionality."
            },
            {
              header: "Analytics cookies",
              desc: "These cookies track visitor traffic and sources, gathering data to understand popular products and actions."
            },
            {
              header: "Marketing cookies",
              desc: "Marketing and advertising partners set these cookies to create your interest profile for showing relevant ads later. Disabling them means no targeted ads based on your interests."
            }
          ],
          accept_all: "Accept all",
          save: "Save preferences"
        }
      },
      fr: {
        banner: {
          title: "Nous respectons votre vie privée !",
          description: "En cliquant sur “Tout accepter”, vous acceptez que notre site Web puisse stocker des cookies sur votre appareil et divulguer des informations conformément à notre politique de cookies.",
          accept_all: "Tout accepter",
          manage: "Gérer les préférences",
          privacy_policy: "Politique de confidentialité"
        },
        prefs: {
          title: "Préférences de consentement aux cookies",
          disclaimer_title: "Utilisation des cookies",
          disclaimer_desc: "Notre site Web utilise des cookies pour améliorer votre expérience de navigation. Ces cookies ne vous identifient pas directement, mais personnalisent votre visite. Vous pouvez gérer vos préférences, bien que le blocування de certains cookies puisse affecter les services du site.",
          categories: [
            {
              header: "Cookies strictement nécessaires",
              desc: "Ces cookies sont essentiels au fonctionnement du site et ne peuvent pas être bloqués. Les bloquer pourrait affecter le bon fonctionnement de notre site."
            },
            {
              header: "Cookies de fonctionnalité",
              desc: "Ces cookies ajoutent des fonctionnalités supplémentaires et de la personnalisation à notre site. Ils sont définis par nous ou des fournisseurs tiers. Ne pas les autoriser peut affecter certaines fonctionnalités des services."
            },
            {
              header: "Cookies d'analyse",
              desc: "Ces cookies suivent le trafic des visiteurs et les sources, collectant des données pour comprendre les produits populaires et les actions."
            },
            {
              header: "Cookies marketing",
              desc: "Les partenaires marketing et publicitaires définissent ces cookies pour créer votre profil d'intérêt et vous afficher des publicités pertinentes plus tard. Les désactiver signifie qu'aucune publicité ciblée ne sera diffusée en fonction de vos centres d'intérêt."
            }
          ],
          accept_all: "Tout accepter",
          save: "Enregistrer les préférences"
        }
      }
    };

    // Визначаємо мову за атрибутом <html lang="...">
    var locale = document.documentElement.getAttribute('lang') || 'en';
    if (!translations[locale]) locale = 'en';

    // Функція для підміни текстів банера
    function replaceBanner() {
      var map = translations[locale].banner;
      var banner = document.getElementById('tinycookie-wrapper');
      if (!banner) return;
      banner.querySelector('.tinycookie-title').textContent = map.title;
      banner.querySelector('.tinycookie-description').textContent = map.description;
      banner.querySelector('.tinycookie-accept-all').textContent = map.accept_all;
      // друга кнопка — non .tinycookie-accept-all
      banner.querySelectorAll('.tinycookie-button')[1].textContent = map.manage;
      banner.querySelector('.tinycookie-privacy-policy').textContent = map.privacy_policy;
    }

    // Функція для підміни текстів сторінки налаштувань
    function replacePrefs() {
      var map = translations[locale].prefs;
      var prefs = document.getElementById('tinycookie-preferences-wrapper');
      if (!prefs) return;

      // Заголовок і опис зверху
      prefs.querySelector('.tinycookie-preferences-header-title').textContent = map.title;
      // disclaimer title + desc
      var disc = prefs.querySelector('.tinycookie-preferences-content-disclaimer');
      disc.querySelector('.tinycookie-preferences-content-disclaimer-title').textContent = map.disclaimer_title;
      disc.querySelector('.tinycookie-preferences-content-disclaimer-description').textContent = map.disclaimer_desc;

      // Категорії куків
      var items = prefs.querySelectorAll('.tinycookie-preferences-preference');
      items.forEach(function(item, idx) {
        if (!map.categories[idx]) return;
        var headerEl = item.querySelector('.tinycookie-preferences-preference-header');
        // текст до <input> — заголовок
        headerEl.childNodes[0].textContent = map.categories[idx].header;
        item.querySelector('.tinycookie-preferences-preference-content').textContent = map.categories[idx].desc;
      });

      // Кнопки внизу
      prefs.querySelector('.tinycookie-preferences-accept').textContent = map.accept_all;
      prefs.querySelector('.tinycookie-preferences-save').textContent = map.save;
    }

    // Викликаємо обидві підміни
    function doReplace() {
      replaceBanner();
      replacePrefs();
    }

    // Спостерігач за появою елементів
    var obs = new MutationObserver(function(muts) {
      muts.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (!(node instanceof HTMLElement)) return;
          if (node.id === 'tinycookie-wrapper' || node.id === 'tinycookie-preferences-wrapper') {
            doReplace();
          }
        });
      });
    });
    obs.observe(document.body, { childList: true, subtree: true });

    // І «примусово» запустимо одразу
    doReplace();
  });
